import React from "react";
import { NavLink } from "react-router-dom";
import styles from "../../styles/TabNavigation.module.scss";

const TabNavigation = (props) => {
  const { routes, children, activeSubtab, setSubTab } = props;

  return (
    <>
      <ul className={styles.tabWrapper}>
        {routes.map((route) => {
          const active = route.path === activeSubtab ? styles.selected : styles.subtab;
          return (
            <NavLink
              key={route.name}
              to={route.path}
              onClick={(e) => setSubTab(route.path)}
              activeStyle={{
                background: "#FAAE31",
                fontWeight: "500",
              }}
            >
              <span className={active}>{route.name}</span>
            </NavLink>
          );
        })}
      </ul>
      {children}
    </>
  );
};

export default TabNavigation;
